export default {
  // 欢迎页面
  welcome: {
    title: '欢迎使用 AhaCreator',
    description: '了解 AhaCreator 的运作方式，并掌握创建、设置和启动达人营销的步骤，从而实现营销效果。',
    startButton: '开始你的第一个营销计划',
  },

  // 步骤说明
  steps: {
    header: '7 个简单步骤设置您的营销计划并启动',
    step1: {
      title: '步骤 1：输入你的产品网站',
      description: 'AhaCreator 将简化设置流程，并在整个过程中提供个性化推荐。',
    },
    step2: {
      title: '步骤 2：选择活动目标',
      description: '选择你的主要转化目标，以获得最佳效果，例如促进销售、获取潜在客户或提升网站流量。',
    },
    step3: {
      title: '步骤 3：确认最高 CPC 和预算上限',
      description: '确认最高点击成本（CPC），然后设置每月预算上限、投放地区和语言，以获得实时效果预估。',
    },
    step4: {
      title: '步骤 4：确认你的受众',
      description: 'AhaCreator 会为你匹配受众；该受众将作为推广产品的起点。',
    },
    step5: {
      title: '步骤 5：启动活动',
      description: '验证支付方式，确认转化追踪，并在准备就绪后启动活动。',
    },
    step6: {
      title: '步骤 6：及时确认达人和内容',
      description: '请在 1 天内确认达人，并在 2 天内审核他们的脚本和初稿，以避免自动进入下一流程。',
    },
    step7: {
      title: '步骤 7：获取结果与报告',
      description: '我们会为你提供每周的效果总结。在 AI 自动驾驶模式下，你无需每天查看数据或频繁决策。',
    },
  },
};
